export const consumerAppBaseUrl = import.meta.env.VITE_CONSUMER_APP_API_URL;
export const happyMoneyBaseUrl = import.meta.env.VITE_HAPPYMONEY_APP_API_URL;
